export enum FormType {
  PrimaryEndorsement = 'CCE',
  ExcessEndorsement = 'CCXS',
}

export enum FormEdition {
  June2023 = '06/2023',
}

export const DEFAULT_FORM_EDITION = FormEdition.June2023;

export const formatConvergeFormNumber = ({
  type,
  number,
  edition = DEFAULT_FORM_EDITION,
}: {
  number: number | string;
  edition?: string;
  type: FormType;
}) => {
  return `${type} ${number} (ed ${edition})`;
};

export const formatConvergeFormNumberForEndorsement = (
  data:
    | {
        number: number | string;
        type?: FormType;
        edition?: string;
      }
    | number
    | string
) => {
  if (data === null || data === undefined) {
    throw new Error('data must be an object or a string/number');
  }
  if (typeof data === 'number' || typeof data === 'string') {
    return formatConvergeFormNumber({
      type: FormType.PrimaryEndorsement,
      number: data,
    });
  }

  return formatConvergeFormNumber({
    type: data.type ?? FormType.PrimaryEndorsement,
    number: data.number,
    edition: data.edition,
  });
};
